import { each, filter, pipe } from '@fxts/core';
import { $ } from 'rune-ts';

let lazy_observer: IntersectionObserver;

export const LAZY_LOAD_CLASS = 'lazy-load';
export const LAZY_LOADED_CLASS = 'lazy-loaded';

export const initLazyLoad = () => {
  lazy_observer = new IntersectionObserver(
    (entries) => {
      pipe(
        entries,
        filter((entry) => entry.isIntersecting),
        each((entry) => {
          const entry$ = $(entry.target);
          if (entry$.hasClass(LAZY_LOAD_CLASS)) {
            const data_src = entry$.getAttribute('data-src');
            const data_srcset = entry$.getAttribute('data-srcset');
            const data_background = entry$.getAttribute('data-background');
            if (data_src) {
              entry$.setAttribute('data-src', '').setAttribute('src', data_src);
            }
            if (data_srcset) {
              entry$.setAttribute('data-srcset', '').setAttribute('srcset', data_srcset);
            }
            if (data_background) {
              entry$.setAttribute('data-background', '');
              entry$.element().style.backgroundImage = data_background ? `url('${data_background}')` : '';
            }

            entry$.removeClass(LAZY_LOAD_CLASS);
            entry$.addClass(LAZY_LOADED_CLASS);
          }

          lazy_observer.unobserve(entry$.element());
        }),
      );
    },
    {
      rootMargin: `${window.innerHeight}px 0px ${window.innerHeight}px 0px`,
    },
  );

  each(
    (lazy_el) => {
      lazy_observer.observe(lazy_el);
    },
    document.querySelectorAll(`.${LAZY_LOAD_CLASS}`),
  );
};

export const refreshLazyLoad = () => {
  lazy_observer.disconnect();
  initLazyLoad();
};
